import {isMobile} from 'react-device-detect';
import {BrowserRouter, Route, Routes} from 'react-router-dom';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import MobilePage from './components/mobile/MobilePage';
import RevealMainPage from './components/Main/RevealMainPage';
import RevealMain from './components/Main/RevealMain';
import GenesisSaleMain from './components/Main/GenesisSaleMain';
import {useEffect, useState} from 'react';
import {getState, saleState} from 'utils/sale-state';
import {useDispatch} from 'react-redux';
import {setConfig} from 'redux/slice/configSlice';
import {option, perLogger} from 'utils/per-logger';
import {configRef, getChartData, maintenanceRef, pilotDataRef, serverTimeRef} from './firebase/firebase';
import {onValue} from 'firebase/database';
import AirdropPage from "./components/Airdrop/AirdropPage";
import PilotPage from "./components/Pilot/PilotPage";
import PilotAirdropPreReg from "./components/Pilot/PilotAirdropPreReg";

function App() {
  const dispatch = useDispatch();

  const [config, setGearConfig] = useState();
  const [state, setState] = useState(saleState.none);
  // const [imageUrls, setImageUrls] = useState();
  const [chartData, setChartData] = useState();
  const [maintenance, setMaintenance] = useState();
  const [pilotData, setPilotData] = useState();

  useEffect(() => {
    const ref = configRef;
    const unsubscribe = onValue(ref, (snapshot) => {
      const data = snapshot.val();
      setGearConfig(data);
      perLogger.log(`config 설정 완료`, {
        ignore: [option.prod],
        consoleMode: true,
      });
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const ref = maintenanceRef;
    const unsubscribe = onValue(ref, (snapshot) => {
      const data = snapshot.val();
      setMaintenance(data);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const unsubscribe = onValue(pilotDataRef, (snapshot) => {
      const data = snapshot.val();
      setPilotData(data);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const unsubscribe = onValue(serverTimeRef, (snapshot) => {
      try {
        const offset = snapshot.val();
        const serverTime = Date.now() + offset;

        console.log('서버 시간:', new Date(serverTime).toISOString());
      } catch (error) {
        console.error('Error fetching server time:', error);
        // 오류 시 로컬 시간 반환
        const localTime = Date.now();
        console.log('로컬 시간:', new Date(localTime).toISOString());
      }

    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    getChartData().then((data) => setChartData(data));
  }, []);

  useEffect(() => {
    if (config) {
      getState(config.startAt, config.rounds, maintenance)
        .then((state) => setState(state))
        .catch((e) => console.error(`state 설정 실패`, e));
    }
  }, [config, maintenance]);

  useEffect(() => {
    perLogger.log(`상태 설정 완료 [state: ${state}]`, {
      ignore: [option.prod],
      consoleMode: true,
    });
  }, [state]);

  useEffect(() => {
    if (config) {
      dispatch(setConfig(config));
    }
  }, [config, dispatch]);

  if (isMobile) {
    return (
      <>
        <BrowserRouter basename={''}>
          <Routes>
            <Route
              path={'/genesissale'}
              element={<GenesisSaleMain />}
            ></Route>
            <Route
              path={'/genesissale/mobile'}
              element={<MobilePage />}
            ></Route>
          </Routes>
        </BrowserRouter>
        <BrowserRouter basename={''}>
          <Routes>
            <Route
              path={'/reveal'}
              element={<RevealMainPage />}
            ></Route>
            <Route
              path={'/reveal/mobile'}
              element={<MobilePage />}
            ></Route>
            <Route
                path={"/airdrop"}
                element={<AirdropPage/>}
            />
            <Route path={'/pilot'}>
              <Route index element={<PilotPage data={pilotData} />} />
              <Route path='airdrop-pre-registration' element={<PilotAirdropPreReg data={pilotData}/>} />
            </Route>
          </Routes>
        </BrowserRouter>
        {/*<BrowserRouter basename={''}>*/}
        {/*  <Routes>*/}
        {/*    <Route*/}
        {/*      path={'/gear'}*/}
        {/*      element={*/}
        {/*        <GearMainMobile*/}
        {/*          config={config}*/}
        {/*          state={state}*/}
        {/*          imgs={noticePopupImgs}*/}
        {/*          chartData={chartData}*/}
        {/*        />*/}
        {/*      }*/}
        {/*    ></Route>*/}
        {/*    <Route*/}
        {/*      path={'/gear/mobile'}*/}
        {/*      element={*/}
        {/*        <GearMainMobile*/}
        {/*          config={config}*/}
        {/*          state={state}*/}
        {/*          imgs={noticePopupImgs}*/}
        {/*          chartData={chartData}*/}
        {/*        />*/}
        {/*      }*/}
        {/*    ></Route>*/}
        {/*  </Routes>*/}
        {/*</BrowserRouter>*/}
      </>
    );
  }
  return (
    <>
      <BrowserRouter basename={''}>
        <Routes>
          <Route
            path={'/genesissale'}
            element={<GenesisSaleMain />}
          ></Route>
          <Route
            path={'/reveal'}
            element={<RevealMain />}
          ></Route>
          <Route
            path={'/airdrop'}
            element={<AirdropPage/>}
          />
          <Route path='/pilot'>
            <Route index element={<PilotPage data={pilotData}/>} />
            {/*<Route path='airdrop-pre-registration' element={<PilotAirdropPreReg />} />*/}
          </Route>

          {/* TODO: 중첩 라우팅 하면 pilotData가 읽히지 않는 문제. Outlet 사용해도 동작 X 임시로 나눠서 라우팅함 */}
          <Route path={'/pilot/airdrop-pre-registration'}
                 element={<PilotAirdropPreReg data={pilotData}/>}
          />
          {/*<Route*/}
          {/*  path={'/gear'}*/}
          {/*  element={*/}
          {/*    <GearMain*/}
          {/*      config={config}*/}
          {/*      state={state}*/}
          {/*      imgs={noticePopupImgs}*/}
          {/*      chartData={chartData}*/}
          {/*    />*/}
          {/*  }*/}
          {/*></Route>*/}
          {/*{env.isTestMode && (*/}
          {/*  <Route*/}
          {/*    path={'/test'}*/}
          {/*    element={<TestComponent />}*/}
          {/*  ></Route>*/}
          {/*)}*/}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
